module.exports = __webpack_public_path__ + "img/4_16.6ed5c3b8.png";